import { render, staticRenderFns } from "./talents_detail.vue?vue&type=template&id=751584b1&scoped=true"
import script from "./talents_detail.vue?vue&type=script&lang=js"
export * from "./talents_detail.vue?vue&type=script&lang=js"
import style0 from "./talents_detail.vue?vue&type=style&index=0&id=751584b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751584b1",
  null
  
)

export default component.exports